(function ($) {
  "use strict";

  var pingday = {
    init: function () {
      this.mainMenuBlock();
      this.mainMenuBlock1();
      this.submenuOpener();
      this.stickyHeader();
      this.showIconOnHover();
      this.twoColsSlider();
      this.linkBoxSlider();
      this.newsSlider();
      this.maximizeFAQ();
      this.customAccordion();
      this.pillsOpener();
      this.blogSlider();
      this.whiteFilterBox();
      this.numberCounter();
      this.clearInputText();
      // this.stepForm();
      this.heroAnimation();
      // this.animatedText();
    },

    mainMenuBlock: function () {
      jQuery("header").on("click", ".navbar-toggle-btn", function (e) {
        e.preventDefault();
        if (!jQuery(this).hasClass("nav-open")) {
          jQuery("#navbar").removeClass("active");
          jQuery("html").removeClass("menu-active");
          jQuery(this).removeClass("nav-close").addClass("nav-open");
        } else {
          jQuery("#navbar").addClass("active");
          jQuery("html").addClass("menu-active");
          jQuery(this).removeClass("nav-open").addClass("nav-close");
        }
      });
    },

    mainMenuBlock1: function () {
      jQuery("header").on(
        "click",
        ".navbar-toggle-btn.nav-close",
        function (e) {
          jQuery("html").removeClass("submenu-active");
          jQuery(".nav-item").removeClass("opened");
          jQuery(".submenu-opener").removeClass("closed");
          jQuery(".dropdown-menu").css("display", "none");
        }
      );
    },

    submenuOpener: function () {
      jQuery("header.main-header .navbar-nav .submenu-opener").on(
        "click",
        function (e) {
          // e.preventDefault();
          jQuery("html").toggleClass("submenu-active");

          if (!jQuery(this).hasClass("closed")) {
            jQuery(this).addClass("closed");
            jQuery(this).parent(".nav-item").addClass("opened");
            jQuery(this).next(".dropdown-menu").slideToggle();
          } else {
            jQuery(this).removeClass("closed");
            jQuery(this).parent(".nav-item").removeClass("opened");
            jQuery(this).next(".dropdown-menu").slideToggle();
          }
        }
      );
    },

    stickyHeader: function () {
      jQuery(function () {
        function toggleStickyHeader() {
          var sticky = jQuery("header"),
            scroll = jQuery(window).scrollTop();

          if (scroll >= 1) {
            sticky.addClass("sticky-header");
          } else {
            sticky.removeClass("sticky-header");
          }
        }

        jQuery(window).on("scroll", toggleStickyHeader);
        toggleStickyHeader(); // Trigger once on page load
      });
    },



    showIconOnHover: function () {
      $(document).ready(function () {
        function initHoverEffect() {
          if ($(window).width() >= 992) {
            // enable hover effect
            $('.link-box-wrapper .single-box').off('mouseenter mouseleave').hover(
              function () {
                $(this).find('.text-content img').stop(true, true).slideDown(300);
              },
              function () {
                $(this).find('.text-content img').stop(true, true).slideUp(300);
              }
            );
          } else {
            // remove hover effect and reset styles
            $('.link-box-wrapper .single-box').off('mouseenter mouseleave');
            $('.link-box-wrapper .single-box .text-content img').stop(true, true).slideDown(0).show();
          }
        }

        // Initialize on load
        initHoverEffect();

        // Re-check when resizing
        $(window).on('resize', function () {
          initHoverEffect();
        });
      });
    },

    twoColsSlider: function () {


      mobileOnlySlider(".two-cols-slider .main-slider", true, false, 991);

      function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
          mobileFirst: true,
          dots: $dots,
          arrows: $arrows,
          autoplay: false,
          infinite: true,
          slidesToShow: 1,

          responsive: [
            {
              breakpoint: $breakpoint,
              settings: "unslick",
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
              }
            }
          ],
        };

        slider.slick(settings);

        $(window).on("resize", function () {
          if ($(window).width() > $breakpoint) {
            return;
          }
          if (!slider.hasClass("slick-initialized")) {
            return slider.slick(settings);
          }
        });
      } // Mobile Only Slider

    },

    linkBoxSlider: function () {

      mobileOnlySlider2(".link-box-slider", true, false, 991);

      function mobileOnlySlider2($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
          mobileFirst: true,
          dots: $dots,
          arrows: $arrows,
          autoplay: false,
          infinite: true,
          slidesToShow: 1,

          responsive: [
            {
              breakpoint: $breakpoint,
              settings: "unslick",
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
              }
            }
          ],
        };

        slider.slick(settings);

        $(window).on("resize", function () {
          if ($(window).width() > $breakpoint) {
            return;
          }
          if (!slider.hasClass("slick-initialized")) {
            return slider.slick(settings);
          }
        });
      } // Mobile Only Slider

    },

    newsSlider: function () {


      mobileOnlySlider3(".news-slider", true, false, 991);

      function mobileOnlySlider3($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
          mobileFirst: true,
          dots: $dots,
          arrows: $arrows,
          autoplay: false,
          infinite: true,
          slidesToShow: 1,

          responsive: [
            {
              breakpoint: $breakpoint,
              settings: "unslick",
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
              }
            }
          ],
        };

        slider.slick(settings);

        $(window).on("resize", function () {
          if ($(window).width() > $breakpoint) {
            return;
          }
          if (!slider.hasClass("slick-initialized")) {
            return slider.slick(settings);
          }
        });
      } // Mobile Only Slider

    },


    maximizeFAQ: function () {
      jQuery(document).on('click', '.fixed-faq-block .top-block', function (e) {
        jQuery('.fixed-faq-block').toggleClass("maximized");
      });
    },




    customAccordion: function () {
      $('.Accordions').each(function () {
        var $accordion = $(this);

        // Activate first item only if NOT alt2
        if (!$accordion.hasClass('alt2')) {
          $accordion.find('.Accordion_item:first .title_tab')
            .addClass('active')
            .next()
            .stop()
            .slideDown(300);
        }

        // Click handler for only this accordion
        $accordion.find('.title_tab').on('click', function (e) {
          e.preventDefault();
          var $this = $(this);

          if ($this.hasClass('active')) {
            $this.removeClass('active')
              .next().stop().slideUp(500);
          } else {
            $this.addClass('active')
              .next().stop().slideDown(500);

            $this.parent().siblings().children('.title_tab').removeClass('active');
            $this.parent().siblings().children('.inner_content').slideUp(500);
          }
        });
      });

    },

    pillsOpener: function () {
      jQuery('.pills-opener').on('click', function () {

        jQuery('.pills-tab-wrapper').toggleClass('open-navpills');

      });

      jQuery('.pills-tab-wrapper a.nav-link').on('click', function () {

        jQuery('.pills-tab-wrapper').removeClass('open-navpills');
      });
    },

    blogSlider: function () {
      $('.blog-slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [

          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              arrows: false,
              dots: true,
              infinite: true,

            }
          },
        ]
      });

      jQuery(".blog-slider-block .left-arrow").click(function () {
        jQuery(".blog-slider .slick-prev ").trigger("click");
        return false;
      });

      jQuery(".blog-slider-block .right-arrow").click(function () {
        jQuery(".blog-slider .slick-next").trigger("click");
        return false;
      });

    },




    whiteFilterBox: function () {
      $(document).ready(function () {
        $('.white-filter-box .heading').on('click', function () {
          var $statusBox = $(this).closest('.white-filter-box');
          var $indicator = $(this).find('.indicator');

          $statusBox.toggleClass('closed');
          $statusBox.children(':not(.heading)').stop().slideToggle(300);
          $indicator.text($indicator.text() === '-' ? '+' : '-');
        });

        // On load: close white-filter-box.alt2 if screen < 767px
        if ($(window).width() < 992) {
          $('.white-filter-box.alt2').each(function () {
            var $box = $(this);
            $box.addClass('closed');
            $box.children(':not(.heading)').hide();
            $box.find('.indicator').text('+');
          });
        }
      });
    },

    numberCounter: function () {
      var a = 0;
      $(window).scroll(function () {

        var oTop = $('#counter').length && $('#counter').offset().top - window.innerHeight;
        if (a == 0 && $(window).scrollTop() > oTop) {
          $('.counter-value').each(function () {
            var $this = $(this),
              countTo = $this.attr('data-count');
            $({
              countNum: $this.text()
            }).animate({
              countNum: countTo
            },

              {

                duration: 3000,
                easing: 'swing',
                step: function () {
                  $this.text(Math.floor(this.countNum));
                },
                complete: function () {
                  $this.text(this.countNum);
                  //alert('finished');
                }

              });
          });
          a = 1;
        }

      });
    },

    clearInputText: function () {

      $('.has-clear-text-btn input[type="text"]').on('input propertychange', function () {
        var $this = $(this);
        var visible = Boolean($this.val());
        $this.siblings('.clear-text').toggleClass('hidden', !visible);
      }).trigger('propertychange');

      $('.clear-text').click(function () {
        $(this).siblings('input[type="text"]').val('')
          .trigger('propertychange').focus();
      });
    },

    stepForm: function () {
      document.addEventListener("DOMContentLoaded", function () {
        const steps = Array.from(document.querySelectorAll(".single-step"));

        // Show only first step initially
        steps.forEach((step, i) => {
          step.style.display = i === 0 ? "" : "none";
        });

        // Function to hide and reset from a given index
        function hideAndResetFrom(index) {
          for (let i = index; i < steps.length; i++) {
            const s = steps[i];
            s.style.display = "none";
            s.querySelectorAll("input, textarea, select").forEach(el => {
              if (el.type === "radio" || el.type === "checkbox") el.checked = false;
              else el.value = "";
            });
          }
        }

        steps.forEach((step, idx) => {
          const radios = step.querySelectorAll("input[type='radio']");

          radios.forEach(radio => {
            radio.addEventListener("change", function () {
              // Always hide & reset everything after this step
              hideAndResetFrom(idx + 1);

              // If a radio is selected, show next step (freshly reset)
              const nextStep = steps[idx + 1];
              if (radio.checked && nextStep) {
                nextStep.style.display = "";
              }
            });
          });
        });
      });

      document.addEventListener("DOMContentLoaded", function () {
        const steps = document.querySelectorAll(".single-step");
        const progressBar = document.querySelector(".progress-bar");
        const totalSteps = steps.length;

        // Update progress when a radio is selected
        steps.forEach((step, index) => {
          const radios = step.querySelectorAll('input[type="radio"]');
          radios.forEach((radio) => {
            radio.addEventListener("change", () => {
              const completedSteps = index + 1;
              const percent = Math.round((completedSteps / totalSteps) * 100);
              progressBar.style.width = percent + "%";
            });
          });
        });

        // Make progress bar 100% on button click
        const elementsWithClass = document.getElementsByClassName('final-step-btn');
        if (elementsWithClass.length > 0) {
          const submitBtn = document.querySelector(".final-step-btn");

          submitBtn.addEventListener("click", (e) => {
            // e.preventDefault(); // prevent actual link click if needed
            progressBar.style.width = "100%";
          });
        }

      });

    },



    heroAnimation: function () {
      gsap.registerPlugin(ScrollTrigger); // register once globally

      const app = {
        heroAnimation1: function () {
          gsap.registerPlugin(ScrollTrigger);

          const banner1 = document.getElementById("banner1");
          const bannerText1 = document.getElementById("banner-text1");
          const logoTextWrapper = banner1.querySelector(".logo-text-block");
          const logoText = banner1.querySelector(".logo-text");

          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: banner1,
              start: "top top",
              end: "+=100%",
              scrub: 0.3,
              pin: true,
              anticipatePin: 1,
              onUpdate: (self) => {
                // progress between 0 and 1 — we can track where the animation is
                const progress = self.progress;

                // Check when the logoTextWrapper tween is active
                const scale = gsap.getProperty(logoTextWrapper, "scale");
                if (scale <= 0.25) {
                  document.body.classList.add("show-main-logo");
                } else {
                  document.body.classList.remove("show-main-logo");
                }
              },
            },
          });

          tl.to(bannerText1, {
            opacity: 1,
            y: 0,
            ease: "power2.out",
            duration: .4,
          });

          tl.to(logoText, {
            opacity: 0,
            duration: 0.1,
          }, "<");

          tl.to(logoTextWrapper, {
            // yPercent: -50,
            top: "0%",
            scale: 0.15,
            ease: "power2.inOut",
            duration: 0.4,

          }, "<");
        },


        // heroAnimation2: function () {
        //   const banner = document.getElementById("banner2");
        //   if (!banner) return; // safety check

        //   const bannerText = document.getElementById("banner-text2");
        //   const backImage = banner.querySelector(".back-image2");
        //   const frontImage = banner.querySelector(".front-image2");
        //   const actionButton = document.getElementById("action-button2");

        //   const tl = gsap.timeline({
        //     scrollTrigger: {
        //       trigger: banner,
        //       start: "top top",
        //       end: "+=300%",
        //       scrub: true,
        //       pin: true,
        //       anticipatePin: 1,
        //     }
        //   });

        //   tl.to(bannerText, {
        //     opacity: 1,
        //     y: 0,
        //     ease: "power2.out",
        //     duration: 1.5,
        //   });

        //   if (window.innerWidth > 991) {
        //     // Desktop
        //     tl.to(backImage, {
        //       borderRadius: "50%",
        //       width: "35vw",
        //       height: "35vw",
        //       top: "50%",
        //       left: "50%",
        //       xPercent: -50,
        //       yPercent: -50,
        //       position: "absolute",
        //       scale: 1.2,
        //       ease: "power2.inOut",
        //       duration: 1,
        //     }, "<");

        //   } else if (window.innerWidth > 767) {
        //     // Tablet
        //     tl.to(backImage, {
        //       borderRadius: "50%",
        //       width: "80vw",
        //       height: "80vw",
        //       position: "absolute",
        //       scale: 1,
        //       ease: "power2.inOut",
        //       duration: 1,
        //       xPercent: -50,
        //       yPercent: -50,
        //       top: "50%",
        //       left: "50%",
        //     }, "<");

        //   } else {
        //     // Mobile
        //     tl.to(backImage, {
        //       borderRadius: "50%",
        //       width: "130vw",
        //       height: "130vw",
        //       position: "absolute",
        //       scale: 1,
        //       ease: "power2.inOut",
        //       duration: 4,
        //       xPercent: -50,
        //       yPercent: -50,
        //       top: "100%",
        //       left: "50%",
        //     }, "<");
        //   }

        //   if (window.innerWidth > 767) {
        //     tl.to(frontImage, {
        //       y: window.innerHeight * 0.9,
        //       scale: 1.6,
        //       ease: "none",
        //       duration: 2,
        //     }, "<");
        //   } else {
        //     tl.to(frontImage, {
        //       y: window.innerHeight * 0.5,
        //       scale: 1.2,
        //       ease: "none",
        //       duration: 3,
        //     }, "<");
        //   }

        //   tl.to(actionButton, {
        //     opacity: 1,
        //     y: 0,
        //     duration: 0.5,
        //     onStart: () => actionButton.classList.add("visible"),
        //   });

        //   tl.to(backImage, {
        //     scale: 1,
        //   }, "<");

        //   if (window.innerWidth > 767) {
        //     tl.to(frontImage, {
        //       y: window.innerHeight * 1.4,
        //       ease: "none",
        //       duration: 2,
        //       scale: 1.6,
        //     }, "<");
        //   } else {
        //     tl.to(frontImage, {
        //       opacity: 1,
        //       ease: "power1.out",
        //       duration: 1,
        //     }, "<");
        //   }
        // },
        heroAnimation2: function () {
          const banner = document.getElementById("banner2");
          if (!banner) return;

          const bannerText = document.getElementById("banner-text2");
          const backImage = banner.querySelector(".back-image2");
          const frontImage = banner.querySelector(".front-image2");
          const actionButton = document.getElementById("action-button2");

          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: banner,
              start: "top top",
              end: "+=100%",
              scrub: true,
              pin: true,
              anticipatePin: 1,
            }
          });

          tl.to(bannerText, {
            opacity: 1,
            y: 0,
            ease: "power2.out",
            duration: 1.5,
          });

          if (window.innerWidth > 991) {
            // Desktop
            tl.to(backImage, {
              borderRadius: "50%",
              width: "35vw",
              height: "35vw",
              top: "50%",
              left: "50%",
              xPercent: -50,
              yPercent: -50,
              position: "absolute",
              scale: 1.2,
              ease: "power2.inOut",
              duration: 1,
            }, "<");

          } else if (window.innerWidth > 767) {
            // Tablet
            tl.to(backImage, {
              borderRadius: "50%",
              width: "80vw",
              height: "80vw",
              position: "absolute",
              scale: 1,
              ease: "power2.inOut",
              duration: 1,
              xPercent: -50,
              yPercent: -50,
              top: "50%",
              left: "50%",
            }, "<");

          } else {
            // Mobile
            tl.to(backImage, {
              borderRadius: "50%",
              width: "130vw",
              height: "130vw",
              position: "absolute",
              scale: 1,
              ease: "power2.inOut",
              duration: 4,
              xPercent: -50,
              yPercent: -50,
              top: "100%",
              left: "50%",
            }, "<");
          }

          if (window.innerWidth > 767) {
            tl.to(frontImage, {
              y: window.innerHeight * 0.9,
              scale: 1.6,
              ease: "none",
              duration: 2,
            }, "<");
          } else {
            tl.to(frontImage, {
              y: window.innerHeight * 0.5,
              scale: 1.2,
              ease: "none",
              duration: 3,
            }, "<");
          }

          tl.to(actionButton, {
            opacity: 1,
            y: 0,
            duration: 0.5,
            onStart: () => actionButton.classList.add("visible"),
          });

          tl.to(backImage, {
            scale: 1,
          }, "<");

          if (window.innerWidth > 767) {
            tl.to(frontImage, {
              y: window.innerHeight * 1.4,
              ease: "none",
              duration: 2,
              scale: 1.6,
            }, "<");
          } else {
            tl.to(frontImage, {
              opacity: 1,
              ease: "power1.out",
              duration: 1,
            }, "<");
          }

          // Toggle class based on animation progress
          tl.eventCallback("onUpdate", () => {
            const st = tl.scrollTrigger;
            if (!st) return;

            if (st.progress === 1) {
              document.body.classList.add("show-sticky-header");
            } else {
              document.body.classList.remove("show-sticky-header");
            }
          });

        },

      };


      //  Run only the correct animation based on <body> class
      document.addEventListener("DOMContentLoaded", () => {
        const body = document.body;

        if (body.classList.contains("has-animation1")) {
          app.heroAnimation1();
        }

        if (body.classList.contains("has-animation2")) {
          app.heroAnimation2();
        }
      });

    },




  };

  pingday.init();
})(jQuery);
